import {
	type BlogMetaExternal,
	type ContentCardData,
	type GroupData,
} from '@af/design-system-docs-ui';

import config2023ThemeworkHeader from './_images/config-2023-themework-header.png';
import config2025MaturingTeamsHeader from './_images/config-2025-maturing-teams-header.png';
import config2025RediscoveringCollaborationHeader from './_images/config-2025-rediscovering-collaboration-header.png';
import designingNavigationHeader from './_images/designing-new-navigation-header.png';
import scriptToScreenHeader from './_images/from-script-to-screen-header.png';
import futureRoadmapHeader from './_images/future-roadmap-header.png';
import howWeBuiltANavigationHeader from './_images/how-we-built-a-navigation-header.png';
import powerOfADollarHeader from './_images/power-of-a-dollar-header.png';
import team25DesigningTheFutureHeader from './_images/team-25-designing-the-future-header.png';
import whenWordsMeetMachinesHeader from './_images/when-words-meet-machines-header.png';

const scriptToScreenMeta: BlogMetaExternal = {
	title:
		'From script to screen(s): how I used my life as a screenwriter to craft a hit content strategy',
	description:
		'Content designers can often feel like the delightfully odd weirdo in the triad meeting.',
	image: scriptToScreenHeader,
	publishDate: new Date(2025, 1, 28),
	readTime: '11 min read',
	type: 'Content strategy',
	href: 'https://www.atlassian.com/blog/design/from-script-to-screens-how-i-used-my-other-life-as-a-screenwriter-to-craft-a-hit-content-strategy',
};

const whenWordsMeetMachinesMeta: BlogMetaExternal = {
	title: 'When words meet machines: the future of content design',
	description:
		'Content designers aren’t just considering the user experience. They’re shaping the app itself.',
	image: whenWordsMeetMachinesHeader,
	publishDate: new Date(2025, 1, 28),
	readTime: '3 min read',
	type: 'Content design',
	href: 'https://www.atlassian.com/blog/design/when-words-meet-machines-the-future-of-content-design',
};

const howWeBuiltANavigationMeta: BlogMetaExternal = {
	title: 'How we built a navigation that works for everyone',
	description: 'Discover how we tackled the challenge of creating a unified navigation system.',
	image: howWeBuiltANavigationHeader,
	publishDate: new Date(2025, 0, 31),
	readTime: '9 min read',
	type: 'Cross-craft',
	href: 'https://www.atlassian.com/blog/design/how-we-built-a-navigation-that-works-for-everyone',
};

const theFutureRoadmapMeta: BlogMetaExternal = {
	title: 'The future roadmap – the next decade as a product designer in tech',
	description:
		'Adapting to change: how trends in data, AI, and design-led innovation will shape products.',
	image: futureRoadmapHeader,
	publishDate: new Date(2024, 11, 17),
	readTime: '12 min read',
	type: 'Leadership',
	href: 'https://www.atlassian.com/blog/design/navigating-the-next-decade-as-a-product-designer-in-tech',
};

const designingNewNavigationMeta: BlogMetaExternal = {
	title: 'Designing Atlassian’s new navigation',
	description: 'Journey through the design process of Atlassian’s new navigation.',
	image: designingNavigationHeader,
	publishDate: new Date(2024, 11, 17),
	readTime: '10 min read',
	type: 'App improvements',
	href: 'https://www.atlassian.com/blog/design/designing-atlassians-new-navigation',
};

const thePowerOfADollarMeta: BlogMetaExternal = {
	title: 'The power of a dollar: Quantifying UX challenges',
	description:
		'How user insights and data helped transformed Smart Values into a game changing feature.',
	image: powerOfADollarHeader,
	publishDate: new Date(2024, 11, 17),
	readTime: '6 min read',
	type: 'Design strategy',
	href: 'https://www.atlassian.com/blog/design/the-power-of-a-dollar-quantifying-ux-challenges',
};

export const blogs = [
	scriptToScreenMeta,
	whenWordsMeetMachinesMeta,
	howWeBuiltANavigationMeta,
	theFutureRoadmapMeta,
	designingNewNavigationMeta,
	thePowerOfADollarMeta,
];

const config2025RediscoveringDesign: BlogMetaExternal = {
	title: 'Config 2025: Rediscovering design collaboration with Christina Nguyen White',
	description: 'Learn how design teams achieve stakeholder buy-in and track collaboration.',
	image: config2025RediscoveringCollaborationHeader,
	publishDate: new Date(2025, 4, 28),
	readTime: '22 min',
	type: 'Design',
	href: 'https://youtu.be/-w5ZSmrZiC8',
};

const config2025MaturingTeams: BlogMetaExternal = {
	title: 'Config 2025: Maturing your teams and your leadership',
	description: 'Leaders share their career growth and thoughts on maturing teams and companies.',
	image: config2025MaturingTeamsHeader,
	publishDate: new Date(2025, 5, 13),
	readTime: '41 min',
	type: 'Leadership',
	href: 'https://youtu.be/xkriqGkodQA',
};

const team25DesigningTheFuture: BlogMetaExternal = {
	title: 'Designing the future with Josh Higgins and Charlie Sutton',
	description: 'This breakout session from Team ’25 showcases our latest experience improvements.',
	image: team25DesigningTheFutureHeader,
	publishDate: new Date(2025, 5, 14),
	readTime: '48 min',
	type: 'Design',
	href: 'https://youtu.be/VjFUEOCRw9Q',
};

const config2023ThemeworkTeamwork: BlogMetaExternal = {
	title: 'Config 2023: From themework to teamwork at Atlassian',
	description:
		'A look at building apps as a team sport and unleashing designer productivity at scale.',
	image: config2023ThemeworkHeader,
	publishDate: new Date(2023, 5, 26),
	readTime: '44 min',
	type: 'Teamwork',
	href: 'https://youtu.be/2FSp3d7CVJU',
};

export const talks = [
	team25DesigningTheFuture,
	config2025RediscoveringDesign,
	config2025MaturingTeams,
	config2023ThemeworkTeamwork,
];

export const homePageDesignAtAtlassianCardData: GroupData<ContentCardData>[] = [
	{
		title: 'Design at Atlassian',
		cards: [
			{
				title: 'Designing the future',
				description: 'Breakout session from Team ’25 with Charlie Sutton and Josh Higgins.',
				href: 'https://youtu.be/VjFUEOCRw9Q',
				image: {
					light: team25DesigningTheFutureHeader,
					dark: team25DesigningTheFutureHeader,
				},
				backgroundSize: 'cover',
				externalIconSpacing: 'spacious',
			},
			{
				title: 'From script to screen(s)',
				description: 'How I used my life as a screenwriter to craft a hit content strategy.',
				href: 'https://www.atlassian.com/blog/design/from-script-to-screens-how-i-used-my-other-life-as-a-screenwriter-to-craft-a-hit-content-strategy',
				image: {
					light: scriptToScreenHeader,
					dark: scriptToScreenHeader,
				},
				backgroundSize: 'cover',
				externalIconSpacing: 'spacious',
			},
			{
				title: 'How we built navigation for all',
				description: 'Discover how we tackled creating a unified navigation system.',
				href: 'https://www.atlassian.com/blog/design/how-we-built-a-navigation-that-works-for-everyone',
				image: {
					light: howWeBuiltANavigationHeader,
					dark: howWeBuiltANavigationHeader,
				},
				backgroundSize: 'cover',
				externalIconSpacing: 'spacious',
			},
		],
	},
];
